import { ArdoqId } from '@ardoq/api-types';
import { Method, fetchJson, toRequestOptions } from './api';
import { ApiResponse } from './types';

export type SuggestionApiSuggestionTypes =
  | 'component'
  | 'componentName'
  | 'referenceName'
  | 'tag'
  | 'users'
  | 'workspace'
  | 'customField'
  | 'parent';

const getQuery = <T>(
  suggestionType: SuggestionApiSuggestionTypes,
  name: string,
  workspaceIds?: ArdoqId[] | null,
  componentId?: ArdoqId,
  limit: number = 100
): ApiResponse<T[]> => {
  const request = new Request(
    `/api/suggestion/${suggestionType}?q=${encodeURIComponent(
      name
    )}&limit=${limit}`,
    toRequestOptions(Method.POST, { workspaceIds, componentId })
  );
  return fetchJson<T[]>(request);
};

const getReportSuggestionQuery = <T>(
  suggestionType: SuggestionApiSuggestionTypes,
  name: string,
  workspaceIds?: ArdoqId[] | null
): ApiResponse<T[]> => {
  const url = new URL(
    `/api/report/search/suggestion/${suggestionType}`,
    window.origin
  );
  if (name) {
    url.searchParams.set('q', name);
  }
  const request = new Request(
    url,
    toRequestOptions(Method.POST, { workspaceIds })
  );
  return fetchJson<T[]>(request);
};

export const suggestionApi = {
  getQuery,
  getReportSuggestionQuery,
};
